import { PRIMARY_MARKETS } from '@/constants/markets';

export const getNarrativeCommunityTitle = ({
  companyName,
  primaryIndustryLabel,
  market,
}: {
  companyName: string | undefined | null;
  primaryIndustryLabel: string | undefined | null;
  market: string | undefined | null;
}) => {
  const primaryMarket = market ? PRIMARY_MARKETS[market] : null;
  const marketDemonym = primaryMarket?.demonym;

  if (companyName) return `${companyName} Community`;

  if (primaryIndustryLabel)
    return [primaryIndustryLabel, marketDemonym, 'Community']
      .filter(Boolean)
      .join(' ');

  if (marketDemonym) return `${marketDemonym} Market Community`;

  return 'Community';
};
